export default __webpack_public_path__ + "static/media/5.d7cc1e0c.PNG";